import React from "react";

import { User } from "../../security/User";

export interface AuthConfig {
    authority: string;
    clientId: string;
    silentRedirectUri: string;
    redirectUri: string;
    logoutUri: string;
    authenticationEnabled: boolean;
    noActivityLogoutTimeInMinutes: number;
    defaultUser: User;
}

export const AuthConfigContext = React.createContext<AuthConfig>({
    clientId: "",
    authenticationEnabled: true,
    authority: "",
    redirectUri: "",
    silentRedirectUri: "",
    logoutUri: "",
    noActivityLogoutTimeInMinutes: 20,
    defaultUser: {
        name: "",
        email: "",
        roles: [],
        accessToken: "",
        idToken: "",
        accessRights: [],
        originatorIds: []
    }
});
